import React, {useState} from 'react';
import {Button, Modal} from "@tag/tag-components-react-v4";
import styles from './RemoveCustomerModal.module.scss';
import {OrganisationDTO} from "../../../types/OrganisationDTO";
import DeleteConfirmationModal from ".//DeleteConfirmationModal";
import AppRolesService from "../../../../General/services/AppRolesService";
import {useIsAuthenticated, useMsal} from "@azure/msal-react";
import { ProjectAccents } from "../../../../General/config/projectAccents";

function RemoveCustomerModal(props: { visible: boolean, selectedOrganisation: OrganisationDTO, handleClose: Function, handleDelete: Function, handleSoftDelete: Function, canDeleteEnv: boolean, canSoftDeleteEnv: boolean }) {

    const [deleteConfirmationModalVisible, setDeleteConfirmationModalVisible] = useState(false);
    const [softDeleteConfirmationModalVisible, setSoftDeleteConfirmationModalVisible] = useState(false);
    
    const { accounts } = useMsal();
    const isAuthenticated = useIsAuthenticated();
    
    const renderModalContent = () => {
        let modalContent;

        modalContent = (
            <div className={styles.RemoveCustomerButtonContainer}>
                <div className={styles.RemoveCustomerButtonElement}>
                    <Button
                        text={'Mark for deletion'}
                        onClick={() => setSoftDeleteConfirmationModalVisible(true)}
                        disabled={!props.canSoftDeleteEnv}
                    />
                </div>
                <div className={styles.RemoveCustomerButtonElement}>
                    <Button
                        text={'Delete'}
                        onClick={() => setDeleteConfirmationModalVisible(true)}
                        disabled={!props.canDeleteEnv}
                    />
                </div>
            </div>
        )

        return modalContent;
    }

    let content;
    content = <>
        <Modal
            visible={props.visible}
            accent={ProjectAccents.PoliciesAndProcedures}
            heading={'Remove ' + props.selectedOrganisation.displayedName}
            onCancelButtonClick={() => {
                props.handleClose();
            }}
            onClose={() => props.handleClose()}
            primaryButtonProps={{buttonStyle: {'display': 'none'}}}
        >
            <div>
                {renderModalContent()}
            </div>
        </Modal>
    </>

    return (
        <>
            {content}
            
            {deleteConfirmationModalVisible ?
                <DeleteConfirmationModal
                    isUserAllowed={AppRolesService.canUserDeleteEnvironments(accounts, isAuthenticated)}
                    visible={deleteConfirmationModalVisible}
                    selectedOrganisation={props.selectedOrganisation}
                    handleClose={() => setDeleteConfirmationModalVisible(false)}
                    handleDeletion={props.handleDelete}
                    modalMessage={<>
                        Are you sure you wish to delete {props.selectedOrganisation.displayedName}?
                        <br/><br/>
                        This process is not reversible, and will not be backed up.
                        <br/><br/>
                    </>}
                /> : undefined
            }
            
            {softDeleteConfirmationModalVisible ?
                <DeleteConfirmationModal
                    isUserAllowed={AppRolesService.canUserSoftDeleteAcppEnvironments(accounts, isAuthenticated)}
                    visible={softDeleteConfirmationModalVisible}
                    selectedOrganisation={props.selectedOrganisation}
                    handleClose={() => setSoftDeleteConfirmationModalVisible(false)}
                    handleDeletion={props.handleSoftDelete}
                    modalMessage={<>
                        Are you sure you wish to lock {props.selectedOrganisation.displayedName}?
                        <br/><br/>
                        This environment will be deleted in one month.
                        <br/><br/>
                    </>}
                /> : undefined
            }
        </>
    )
}

export default RemoveCustomerModal;
